/**
 * Local PIN lockout tracking (Phase 8, ADR-009 §3.2).
 *
 * Pure functions over a small persisted record - the caller is responsible
 * for reading/writing it (`local_config`, keyed per user; see
 * `packages/pos-local/src/repos/session.ts`). Mirrors the server's own
 * discipline number-for-number (`apps/api/src/http/middleware/rateLimit.ts`
 * / the account-lockout policy referenced throughout the auth module)
 * rather than inventing a different threshold for the offline path.
 */
export const LOCKOUT_MAX_ATTEMPTS = 5;
export const LOCKOUT_MINUTES = 15;
export const INITIAL_LOCKOUT_STATE = { failedAttempts: 0, lockedUntil: null };
export function isLocked(state, now = new Date()) {
    return Boolean(state.lockedUntil && new Date(state.lockedUntil).getTime() > now.getTime());
}
/** Call after a failed PIN attempt. Locks out once `LOCKOUT_MAX_ATTEMPTS` is reached. */
export function recordFailedAttempt(state, now = new Date()) {
    const failedAttempts = state.failedAttempts + 1;
    if (failedAttempts >= LOCKOUT_MAX_ATTEMPTS) {
        return {
            failedAttempts: 0,
            lockedUntil: new Date(now.getTime() + LOCKOUT_MINUTES * 60_000).toISOString(),
        };
    }
    return { failedAttempts, lockedUntil: state.lockedUntil };
}
/** Call after a successful PIN attempt (also clears an expired lock). */
export function clearLockout() {
    return { ...INITIAL_LOCKOUT_STATE };
}
//# sourceMappingURL=lockout.js.map